import { IconProps } from "../../icons/dto";

export function ArrowsUp(props: IconProps) {
    const { size, color } = props;
    return (
        <svg width={size ?? "24"} height={size ?? "24"} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 20V4M7 4L3 8M7 4L11 8M17 20V9M17 9L13 13M17 9L21 13" stroke={color ?? "black"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    )
}